module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-48.13585850.png";